let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gOG0m")).then(() => parcelRequire('k6JMo'));